module.exports = __webpack_public_path__ + "img/logo.187f3f9e.svg";